import { render, staticRenderFns } from "./SearchByTicket.vue?vue&type=template&id=2520b8bb&scoped=true&"
import script from "./SearchByTicket.vue?vue&type=script&lang=js&"
export * from "./SearchByTicket.vue?vue&type=script&lang=js&"
import style0 from "./SearchByTicket.vue?vue&type=style&index=0&id=2520b8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520b8bb",
  null
  
)

export default component.exports